import { render, staticRenderFns } from "./SettingsTheme.vue?vue&type=template&id=286c02f2"
import script from "./SettingsTheme.vue?vue&type=script&lang=js"
export * from "./SettingsTheme.vue?vue&type=script&lang=js"
import style0 from "./SettingsTheme.vue?vue&type=style&index=0&id=286c02f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports